import { render, staticRenderFns } from "./GiftCardsList.vue?vue&type=template&id=40f27b0a&"
import script from "./GiftCardsList.vue?vue&type=script&lang=js&"
export * from "./GiftCardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports